
<div mat-dialog-title class="title">
    @if(this.isEditMode)
    {
    <span class="heading">Jurisdiction Details</span>
    }
    @else
    {
    <span class="heading">Jurisdiction Details</span>
    }
    <button mat-dialog-close class="close-button" mat-icon-button matSuffix>
        <mat-icon class="close-icon-color">cancel</mat-icon>
    </button>
</div>
<div class="form">
    <form [formGroup]="jurisdictionForm" class="form-fields">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Jurisdiction Name</mat-label>
            <input matInput formControlName="juridictionName" />
            @if
            (jurisdictionForm.controls['juridictionName'].hasError('required'))
            {
            <mat-error>Juridiction name is required</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Jurisdiction Code</mat-label>
            <input matInput formControlName="juridictionCode" />
            @if
            (jurisdictionForm.controls['juridictionCode'].hasError('required'))
            {
            <mat-error>Juridiction code is required</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Organization Key</mat-label>
            <input matInput formControlName="jurisdictionOrgKey" />
            @if
            (jurisdictionForm.controls['jurisdictionOrgKey'].hasError('required'))
            {
            <mat-error>Juridiction organization key is required</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Date Format</mat-label>
            <input matInput formControlName="dateFormat" placeholder="dd/mm/yyyy" />
        </mat-form-field>
    </form>
<div mat-dialog-actions class="action-buttons">
    <button mat-raised-button class="small-update-btn" color="accent" (click)="onSubmit()" [disabled]="jurisdictionForm.invalid">
        Save
    </button>
</div>
</div>
